module.exports = __webpack_public_path__ + "static/media/ida-star.44500b79.gif";